import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import { ATOMS_TYPOGRAPHY_CLASSES } from '../styles/typography.generated';

/**
 * Atoms typography utilities (`text-{family}-{size}`) come from the `--text-*`
 * theme tokens. tailwind-merge's default config doesn't know these custom
 * values, so its greedy `text-color` group swallows them — making
 * `cn('text-od-content-primary', 'text-display-lg')` drop the color (the two
 * land in the same conflict group). Registering them as explicit members of the
 * `font-size` group keeps typography and text-color in separate groups: exact
 * class matches are resolved before the `text-color` validator, so
 * `text-display-lg` → font-size and `text-od-*` → text-color.
 *
 * The class list is generated from `THEME_CONFIG.typography` (the source of
 * truth) by `pnpm generate:themes` → `styles/typography.generated.ts`, so it
 * stays in sync with the ramp automatically.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...ATOMS_TYPOGRAPHY_CLASSES] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
